import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Who is STETH for?",
    a: "STETH is a dating app for healthcare professionals and students: doctors, nurses, dentists, pharmacists, therapists, midwives, allied health, and more. You must be 18 or older to join.",
  },
  {
    q: "Do I have to be verified?",
    a: "No. Verification is optional, but submitting a license or work ID earns a \u201CVerified Healthcare Pro\u201D badge that builds trust with other members.",
  },
  {
    q: "How does STETH keep people safe?",
    a: "We provide in-app reporting, blocking and unmatching, enforce a zero-tolerance policy for objectionable content, and review every report, typically acting within 24 hours.",
  },
  {
    q: "Is it free?",
    a: "You can create a profile, discover people, match and message for free. Any premium features will be clearly described in the app.",
  },
  {
    q: "How do I delete my account?",
    a: "You can delete your account and associated data at any time from Settings in the app.",
  },
];

const Item = ({ q, a, i, open, setOpen }) => {
  const isOpen = open === i;
  return (
    <div className="overflow-hidden rounded-2xl border border-hairline bg-cream">
      <button
        data-testid={`faq-accordion-item-${i}`}
        onClick={() => setOpen(isOpen ? -1 : i)}
        aria-expanded={isOpen}
        className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <span className="text-base font-bold tracking-tight">{q}</span>
        <motion.span
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.3 }}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-peach/60 text-terracotta-dark"
        >
          <Plus size={16} />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="px-6 pb-6 text-sm leading-relaxed text-clay">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-5 py-28 sm:px-8 sm:py-36">
      <Reveal className="text-center">
        <Eyebrow>FAQ</Eyebrow>
        <h2 className="mt-5 font-editorial text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
          Good to <span className="font-normal italic text-terracotta-dark">know</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-12 flex flex-col gap-3.5">
        {FAQS.map((f, i) => (
          <Item key={f.q} q={f.q} a={f.a} i={i} open={open} setOpen={setOpen} />
        ))}
      </Reveal>
    </section>
  );
};
